import { useMemo } from "react";
import {
  ResponsiveContainer,
  AreaChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Area,
} from "recharts";
import { EmptyScreen } from "../../../misc";
import { CustomTooltip } from "@/components/graph/misc";
import { CustomXAxisTick } from "./utils";

interface QueryCountGraphProps {
  data: Array<{
    date: string;
    query_count: number;
  }>;
}

const QueryCountGraph = ({ data }: QueryCountGraphProps) => {
  const stackedData = useMemo(() => {
    if (data.length === 0) return [];
    return data.map(entry => ({
      time: entry.date,
      query_count: entry.query_count,
      query_count_ui: entry.query_count,
    }));
  }, [data]);

  if (stackedData && stackedData.length === 0)
    return (
      <EmptyScreen
        title="No Query Count data found"
        subTitle="No query count data found for the selected period. You will see the data once queries are executed."
      />
    );

  return (
    <ResponsiveContainer minHeight={400} className="mb-4">
      <AreaChart
        data={stackedData}
        margin={{
          top: 50,
          right: 30,
          left: 50,
          bottom: 50,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="time" tick={<CustomXAxisTick />} />
        <YAxis
          label={{
            value: "Total Query Count",
            fill: "black",
            angle: 0,
            position: "insideTopLeft",
            offset: -30,
          }}
        />
        <Tooltip
          content={
            <CustomTooltip
              nameValue={[
                { name: "Date", value: "time", color: "gray" },
                {
                  name: "Total Query Count",
                  value: "query_count_ui",
                  color: "#247EFE",
                },
              ]}
            />
          }
        />
        <Area
          type="linear"
          dataKey="query_count"
          stroke="#247EFE66"
          fill="#247EFE66"
          dot={{
            fill: "#C0D7F9",
            strokeWidth: "1px",
            stroke: "#247EFE",
          }}
          aria-label="Query count over time"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default QueryCountGraph;